export default __webpack_public_path__ + "static/media/cancel.2c27954c.png";